import { type TRoomCountMarker } from '@/entities/map'
import { useOverlay } from '@/shared/lib'

import {
  type RoomCountOverlay,
  type RoomCountOverlayProps,
  createRoomCountOverlay,
} from '.'

import { getContent } from './element'

export const useRoomCountOverlay = () => {
  const manager = useOverlay<
    RoomCountOverlay,
    RoomCountOverlayProps,
    TRoomCountMarker
  >({
    createInstance: createRoomCountOverlay,
    getOverlayOptions: item => ({
      zIndex: 40,
      content: getContent(item.sameGpsCnt),
      nextZoomLevel: item.nextZoomLevel,
    }),
  })

  return manager
}
